// UID: BWR-FIN_STMT_4Y-FILE
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2247

import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { RulesetResult, IsForProfit, HasApplicantNotFiledTR } from '../rules';
import IsFBO from '../rules/IsFBO';
import IsBusinessEstablishedMoreThan from '../rules/IsBusinessEstablishedMoreThan';
import IsBetweenMidAprilMidMay from '../rules/IsBetweenMidAprilMidMay';
import IsBetweenJanAndMidFeb from '../rules/IsBetweenJanAndMidFeb';
import IsBetweenMidFebMidApril from '../rules/IsBetweenMidFebMidApril';

class FinancialStatementFourYearsAgoFullYearRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const establishedMoreThanFourYearsAgo =
      IsBusinessEstablishedMoreThan.setYears(4).evaluate(data);

    if (IsFBO.evaluate(data)) {
      return establishedMoreThanFourYearsAgo
        ? RulesetResult.OPTIONAL
        : RulesetResult.HIDDEN;
    }

    const isNonProfit = !IsForProfit.evaluate(data);
    const hasApplicantNotEverFiledTR = HasApplicantNotFiledTR.evaluate(data);
    const isBetweenJanAndMidApril = [
      IsBetweenJanAndMidFeb,
      IsBetweenMidFebMidApril,
    ].some((rule) => rule.evaluate(data));
    const isBetweenMidAprilAndMidMay = IsBetweenMidAprilMidMay.evaluate(data);

    if (
      isNonProfit &&
      establishedMoreThanFourYearsAgo &&
      hasApplicantNotEverFiledTR
    ) {
      if (isBetweenMidAprilAndMidMay) return RulesetResult.OPTIONAL;
      if (isBetweenJanAndMidApril) return RulesetResult.REQUIRED;
    }
    return RulesetResult.HIDDEN;
  };
}

export default new FinancialStatementFourYearsAgoFullYearRuleset();
